import { PlaceDataSubmissionStatus } from "../types/PlaceDataSubmissionStatus";

export function placeDataSubmissionStatusToText(
  status: PlaceDataSubmissionStatus
): string {
  switch (status) {
    case PlaceDataSubmissionStatus.PENDING:
      return "Pending";
    case PlaceDataSubmissionStatus.UNDER_REVIEW:
      return "Under Review";
    case PlaceDataSubmissionStatus.ACCEPTED:
      return "Accepted";
    case PlaceDataSubmissionStatus.REJECTED:
      return "Rejected";
    case PlaceDataSubmissionStatus.UNKNOWN:
      return "Unknown";
    default:
      return "Unknown";
  }
}
